import Image from 'next/image';

const styles = {
  container: {
    background:
      'linear-gradient(180deg, rgba(242, 250, 255, 0) 0%, #F2FAFF 80.21%, rgba(242, 250, 255, 0) 100%)',
  },
};

export const AdvFeature = () => {
  return (
    <section style={styles.container}>
      <div className="mb-16 mt-20 justify-center md:flex md:flex-wrap">
        {/* card #1 */}
        <div className="mx-8 my-4 flex flex-col items-center justify-center px-4 pb-4 text-center md:mx-8 md:mt-8 md:w-[60%] md:py-4 lg:w-[40%] lg:py-0 lg:pb-[31px] xl:w-[23%]">
          <div className="w-[40%]">
            {/* <OptimisedImage
              defaultImagePath="/images/icons/advfeatures/advfeature-1/advfeature-2x.png"
              data={[
                {
                  imagePath:
                    '/images/icons/advfeatures/advfeature-1/advfeature-2x.png',
                  imageWidth: 1024,
                  alt: 'Save Teacher Time',
                },
              ]}
            /> */}
            <Image
              src="/images/icons/advfeatures/advfeature-1/advfeature-2x.png"
              width={1024}
              height={1024}
              alt="Save Teacher Time"
            />
          </div>
          <h2 className="text-[22px] font-[600] text-[#3d3e40] md:text-[28px]">
            Save Teacher Time
          </h2>
          <p className="text-[17px] text-[#616366] md:text-[18px]">
            One-click data collection, collaboration, and automation of routine
            tasks like report generation mean teachers can focus on instruction
            and leave the paperwork to us.
          </p>
        </div>

        {/* card #2 */}
        <div className="mx-8 my-4 flex flex-col items-center justify-center px-4 pb-4 text-center md:mx-8 md:mt-8 md:w-[60%] md:py-4 lg:w-[40%] lg:py-0 lg:pb-[58px] xl:w-[23%]">
          <div className="w-[40%]">
            {/* <OptimisedImage
              defaultImagePath="/images/icons/advfeatures/advfeature-2/advfeature-2x.png"
              data={[
                {
                  imagePath:
                    '/images/icons/advfeatures/advfeature-2/advfeature-2x.png',
                  imageWidth: 1024,
                  alt: 'Decide with data',
                },
              ]}
            /> */}
            <Image
              src="/images/icons/advfeatures/advfeature-2/advfeature-2x.png"
              width={1024}
              height={1024}
              alt="Decide with data"
            />
          </div>
          <h2 className="text-[22px] font-[600] text-[#3d3e40] md:text-[28px] ">
            Decide with data
          </h2>
          <p className="text-[17px] text-[#616366] md:text-[18px]">
            Easier data collection means more data collection. This, married
            with enhanced data visualization and sharing, promotes data-driven
            instruction for the entire team.
          </p>
        </div>

        {/* card #3 */}
        <div className="mx-8 my-4 flex flex-col items-center justify-center px-4 pb-4 text-center md:mx-8 md:mt-8 md:w-[60%] md:py-4 lg:w-[40%] lg:py-0 lg:pb-[31px] xl:w-[23%]">
          <div className="w-[40%]">
            {/* <OptimisedImage
              defaultImagePath="/images/icons/advfeatures/advfeature-3/advfeature-2x.png"
              data={[
                {
                  imagePath:
                    '/images/icons/advfeatures/advfeature-3/advfeature-2x.png',
                  imageWidth: 1024,
                  alt: 'Improve Compliance',
                },
              ]}
            /> */}
            <Image
              src="/images/icons/advfeatures/advfeature-3/advfeature-2x.png"
              width={1024}
              height={1024}
              alt="Improve Compliance"
            />
          </div>
          <h2 className="text-[22px] font-[600] text-[#3d3e40] md:text-[28px]">
            Improve Compliance
          </h2>
          <p className="text-[17px] text-[#616366] md:text-[18px]">
            Instantaneous reports, smart reminders, and a bird&apos;s eye view
            of the department through the admin dashboard ensure administrators
            have a pulse on real-time compliance.
          </p>
        </div>
      </div>
    </section>
  );
};
